var render, staticRenderFns
import script from "./el-radio-group.vue?vue&type=script&lang=js"
export * from "./el-radio-group.vue?vue&type=script&lang=js"
import style0 from "./el-radio-group.vue?vue&type=style&index=0&id=0558f22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0558f22e",
  null
  
)

export default component.exports